import classNames from "classnames";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuTrigger,
} from "~/components/shared/DropdownMenu";
import Icon from "~/components/shared/Icon";
import { useTrack } from "~/components/build/Show/lib/useTrack";

import {
  DisplayMode,
  useFilterStore,
} from "~/components/build/Show/components/Sidebar/useFilterStore";

const options = {
  [DisplayMode.State]: "States",
  [DisplayMode.Pipeline]: "Pipeline",
};

export default function DisplayModeDropdown() {
  const displayMode = useFilterStore((state) => state.displayMode);
  const setDisplayMode = useFilterStore((state) => state.setDisplayMode);
  const track = useTrack();

  return (
    <DropdownMenu>
      <div className="flex">
        <DropdownMenuTrigger asChild={true}>
          <button
            data-testid="display-mode-dropdown"
            className={classNames(
              "text-charcoal-700 group inline-flex h-7 max-w-full items-center space-x-1 self-stretch rounded-md bg-gray-100 px-2 transition-colors hover:bg-purple-100 hover:text-purple-600 focus:z-10",
            )}
          >
            <Icon icon="custom/outline/group" className="h-3 w-3 shrink-0" />

            {displayMode && (
              <span className="max-w-full truncate">
                <span>Display: </span>
                <span className="font-medium">{options[displayMode]}</span>
              </span>
            )}

            {!displayMode && <span className="max-w-full truncate">Display</span>}

            <Icon icon="down-triangle" className="flex-none" style={{ width: 7, height: 7 }} />
          </button>
        </DropdownMenuTrigger>
      </div>
      <DropdownMenuPortal>
        <DropdownMenuContent
          align="start"
          alignOffset={1}
          data-testid="display-mode-dropdown-content"
        >
          {Object.values(DisplayMode).map((option) => (
            <DropdownMenuItem
              id={option}
              key={option}
              asChild={true}
              active={displayMode === option}
            >
              <button
                onClick={() => {
                  track(`Group Sidebar Steps`, { group_by: option });
                  setDisplayMode(option);
                }}
              >
                {options[option]}
              </button>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenuPortal>
    </DropdownMenu>
  );
}
